import { render, staticRenderFns } from "./AmetrasBase64FieldWrapper.vue?vue&type=template&id=a43dcb68&"
import script from "./AmetrasBase64FieldWrapper.vue?vue&type=script&lang=ts&"
export * from "./AmetrasBase64FieldWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports